module.exports = __webpack_public_path__ + "media/images/emoticons/pisces-361faee5f0f584103e809a11c9da9dee.gif";